import React from 'react';
import PropTypes from 'prop-types';
import { 
  Table, 
  TableBody, 
  TableCell, 
  TableHead, 
  TableRow, 
  Typography, 
  Chip
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import moment from 'moment';
import routePaths from '../../routePaths';

const useStyles = makeStyles((theme) => ({
  emptyState: {
    textAlign: 'center',
    padding: theme.spacing(4),
    color: theme.palette.text.secondary,
  },
  voteDate: {
    fontSize: '0.8rem',
    color: theme.palette.text.secondary,
  },
  statusChip: {
    marginLeft: theme.spacing(1),
  },
  errorState: {
    textAlign: 'center',
    padding: theme.spacing(4),
    color: theme.palette.error.main,
  },
  yearColumn: {
    width: '50%',
    minWidth: '200px',
  },
  statusColumn: {
    width: '25%',
  },
  dateColumn: {
    width: '25%',
  },
  clickableRow: {
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: theme.palette.action.hover,
    },
  },
}));

const getStatusText = (isDraft) => {
  return isDraft ? 'Szkic' : 'Oddany';
};

const getStatusColor = (isDraft) => {
  return isDraft ? 'default' : 'primary';
};

const ParticipantVotes = ({ votes, error }) => {
  const classes = useStyles();

  if (error) {
    return (
      <Typography className={classes.errorState}>
        Wystąpił błąd podczas ładowania głosów: {error.message}
      </Typography>
    );
  }

  if (!votes || votes.length === 0) {
    return (
      <Typography className={classes.emptyState}>
        Nie masz jeszcze żadnych oddanych głosów.
      </Typography>
    );
  }

  return (
    <Table>
      <TableHead>
        <TableRow>
          <TableCell className={classes.yearColumn}>Rok</TableCell>
          <TableCell className={classes.statusColumn}>Status</TableCell>
          <TableCell className={classes.dateColumn}>Ostatnia aktualizacja</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {votes.map((vote, index) => (
          <TableRow 
            key={vote.id || index}
            className={classes.clickableRow}
            onClick={() => window.location.href = `${routePaths.budgetVote}${vote.budgetId}?voteId=${vote.id}`}
          >
            <TableCell className={classes.yearColumn}>
              <Typography variant="subtitle2">
                {vote.budgetYear}
              </Typography>
            </TableCell>
            <TableCell className={classes.statusColumn}>
              <Chip
                label={getStatusText(vote.isDraft)}
                color={getStatusColor(vote.isDraft)}
                size="small"
              />
            </TableCell>
            <TableCell className={classes.dateColumn}>
              <Typography className={classes.voteDate}>
                {moment(vote.lastUpdatedAt).format('YYYY-MM-DD HH:mm')}
              </Typography>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};

ParticipantVotes.propTypes = {
  votes: PropTypes.array,
  error: PropTypes.object,
};

export default ParticipantVotes;



// WEBPACK FOOTER //
// ./src/components/budget/ParticipantVotes.js